import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import TemperatureAndWeather from './TemperatureAndWeather';

import type { ValidationError } from 'sonata-react-components';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  error?: ValidationError;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function TemperatureAndWeatherWrapper({ error, onChange, targeting, user, userRoles }: Props) {
  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <TemperatureAndWeather error={error} />
    </TargetingProvider>
  );
}

export default TemperatureAndWeatherWrapper;
